<template>
    <div class="package-management">
      <!-- <h2>套餐管理</h2> -->
      
      <!-- 操作按钮区 -->
      <div class="operation-area">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加套餐</el-button>
        <el-input
          v-model="searchKeyword"
          placeholder="请输入套餐名称"
          style="width: 250px; margin-left: 10px"
          prefix-icon="el-icon-search"
          @input="handleSearch"
          clearable
        ></el-input>
        <el-select v-model="typeFilter" placeholder="套餐类型" style="width: 140px; margin-left: 10px" clearable>
          <el-option label="体检套餐" value="体检套餐"></el-option>
          <el-option label="健康随访" value="健康随访"></el-option>
          <el-option label="慢病管理" value="慢病管理"></el-option>
          <el-option label="产后康复" value="产后康复"></el-option>
          <el-option label="特需服务" value="特需服务"></el-option>
        </el-select>
        <el-select v-model="starFilter" placeholder="服务星级" style="width: 140px; margin-left: 10px" clearable>
          <el-option label="三星" value="3"></el-option>
          <el-option label="四星" value="4"></el-option>
          <el-option label="五星" value="5"></el-option>
        </el-select>
      </div>
      
      <!-- 套餐表格 -->
      <el-table
        :data="filteredPackages"
        border
        style="width: 100%; margin-top: 15px"
        v-loading="loading"
      >
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column prop="packageCode" label="套餐编码" width="120"></el-table-column>
        <el-table-column prop="name" label="套餐名称" width="180">
          <template slot-scope="scope">
            <div class="package-name">
              <el-image :src="scope.row.image" style="width: 40px; height: 40px; margin-right: 10px"></el-image>
              <div>
                <div>{{ scope.row.name }}</div>
                <el-tag size="mini" effect="plain">{{ scope.row.type }}</el-tag>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="套餐价格" width="120">
          <template slot-scope="scope">
            <span style="color: #f56c6c; font-weight: bold;">¥{{ scope.row.price }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="duration" label="套餐时长" width="120">
          <template slot-scope="scope">
            {{ scope.row.duration }} {{ scope.row.durationUnit }}
          </template>
        </el-table-column>
        <el-table-column prop="serviceLevel" label="服务星级" width="120">
          <template slot-scope="scope">
            <el-rate
              v-model="scope.row.serviceLevel"
              disabled
              text-color="#ff9900"
              score-template="{value}"
            ></el-rate>
          </template>
        </el-table-column>
        <el-table-column prop="features" label="套餐特色" width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag v-for="feature in scope.row.features" :key="feature" size="mini" style="margin-right: 5px; margin-bottom: 5px;">{{ feature }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="套餐内容" show-overflow-tooltip></el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '启用' ? 'success' : 'info'">{{ scope.row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="260" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" :type="scope.row.status === '启用' ? 'info' : 'success'" @click="toggleStatus(scope.row)">
              {{ scope.row.status === '启用' ? '停用' : '启用' }}
            </el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页组件 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
      
      <!-- 添加/编辑套餐对话框 -->
      <el-dialog 
        :title="dialogType === 'add' ? '添加套餐' : '编辑套餐'" 
        :visible.sync="dialogVisible" 
        width="700px"
        :close-on-click-modal="false"
      >
        <el-form :model="packageForm" :rules="packageRules" ref="packageForm" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="套餐名称" prop="name">
                <el-input v-model="packageForm.name" placeholder="请输入套餐名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="套餐编码" prop="packageCode">
                <el-input v-model="packageForm.packageCode" placeholder="请输入套餐编码" :disabled="dialogType === 'edit'"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="套餐类型" prop="type">
                <el-select v-model="packageForm.type" placeholder="请选择套餐类型" style="width: 100%">
                  <el-option label="体检套餐" value="体检套餐"></el-option>
                  <el-option label="健康随访" value="健康随访"></el-option>
                  <el-option label="慢病管理" value="慢病管理"></el-option>
                  <el-option label="产后康复" value="产后康复"></el-option>
                  <el-option label="特需服务" value="特需服务"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="套餐价格" prop="price">
                <el-input-number v-model="packageForm.price" :precision="2" :step="100" :min="0" style="width: 100%"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="套餐时长" prop="duration">
                <el-input-number v-model="packageForm.duration" :min="1" style="width: 70%"></el-input-number>
                <el-select v-model="packageForm.durationUnit" style="width: 30%">
                  <el-option label="天" value="天"></el-option>
                  <el-option label="周" value="周"></el-option>
                  <el-option label="月" value="月"></el-option>
                  <el-option label="年" value="年"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="服务星级" prop="serviceLevel">
                <el-rate v-model="packageForm.serviceLevel" :max="5" style="margin-top: 10px"></el-rate>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-form-item label="套餐特色" prop="features">
            <el-select
              v-model="packageForm.features"
              multiple
              filterable
              allow-create
              default-first-option
              placeholder="请输入套餐特色"
              style="width: 100%"
            >
              <el-option
                v-for="item in featureOptions"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="套餐封面" prop="image">
            <el-upload
              class="avatar-uploader"
              action="/api/upload"
              :show-file-list="false"
              :on-success="handleImageSuccess"
              :before-upload="beforeImageUpload"
            >
              <img v-if="packageForm.image" :src="packageForm.image" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          
          <el-form-item label="套餐内容" prop="description">
            <el-input type="textarea" v-model="packageForm.description" :rows="4" placeholder="请输入套餐详细内容"></el-input>
          </el-form-item>
          
          <el-form-item label="状态">
            <el-radio-group v-model="packageForm.status">
              <el-radio label="启用">启用</el-radio>
              <el-radio label="停用">停用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </template>
  
  <script>
  export default {
    name: 'package-management',
    data() {
      return {
        // 套餐列表数据
        packageList: [
          {
            id: 1,
            packageCode: 'PKG10001',
            name: '全面体检套餐A',
            type: '体检套餐',
            price: 1999.00,
            duration: 3,
            durationUnit: '月',
            serviceLevel: 5,
            features: ['全套检查', '专家解读', '一对一跟踪'],
            description: '包含血常规、尿常规、肝功能、心电图、B超等全面体检项目，由专家提供一对一解读服务，赠送3个月健康跟踪随访。',
            status: '启用',
            image: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'
          },
          {
            id: 2,
            packageCode: 'PKG10002',
            name: '高血压管理方案',
            type: '慢病管理',
            price: 2499.00,
            duration: 6,
            durationUnit: '月',
            serviceLevel: 4,
            features: ['定期监测', '用药指导', '饮食建议'],
            description: '针对高血压患者的专业管理方案，包含每周一次血压监测，每月一次医生面诊，提供个性化用药和饮食建议，帮助患者有效控制血压。',
            status: '启用',
            image: 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png'
          },
          {
            id: 3,
            packageCode: 'PKG10003',
            name: '孕产妇护理套餐',
            type: '产后康复',
            price: 3999.00,
            duration: 12,
            durationUnit: '周',
            serviceLevel: 5,
            features: ['产前检查', '产后护理', '婴儿照护'],
            description: '为孕产妇提供全周期服务，包含产前检查、产后恢复训练、婴儿照护指导、营养咨询等服务，由专业医护团队提供一站式解决方案。',
            status: '启用',
            image: 'https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg'
          },
          {
            id: 4,
            packageCode: 'PKG10004',
            name: '健康随访基础包',
            type: '健康随访',
            price: 999.00,
            duration: 1,
            durationUnit: '年',
            serviceLevel: 3,
            features: ['电话随访', '健康档案', '线上咨询'],
            description: '提供电话定期随访、健康档案管理、线上咨询等基础服务，适合一般体检后的健康管理需求。',
            status: '停用',
            image: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg'
          },
          {
            id: 5,
            packageCode: 'PKG10005',
            name: '糖尿病专项管理',
            type: '慢病管理',
            price: 2799.00,
            duration: 6,
            durationUnit: '月',
            serviceLevel: 4,
            features: ['血糖监测', '专家会诊', '饮食指导'],
            description: '为糖尿病患者提供专业化管理服务，包含定期血糖监测、每月专家面诊、个性化饮食指导、并发症筛查等，帮助患者稳定血糖水平。',
            status: '启用',
            image: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'
          },
          {
            id: 6,
            packageCode: 'PKG10006',
            name: '特需VIP诊疗服务',
            type: '特需服务',
            price: 9999.00,
            duration: 1,
            durationUnit: '年',
            serviceLevel: 5,
            features: ['专家团队', '绿色通道', '一对一服务'],
            description: '由医院顶级专家团队提供一对一诊疗服务，开通就医绿色通道，提供私人健康管家，全年不限次数电话咨询，享受最高级别医疗服务。',
            status: '启用',
            image: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
          }
        ],
        // 套餐特色选项
        featureOptions: [
          '全套检查', '专家解读', '一对一跟踪', '定期监测', '用药指导', '饮食建议', 
          '产前检查', '产后护理', '婴儿照护', '电话随访', '健康档案', '线上咨询',
          '血糖监测', '专家会诊', '专家团队', '绿色通道', '一对一服务'
        ],
        // 表格加载状态
        loading: false,
        // 搜索关键词
        searchKeyword: '',
        // 类型筛选
        typeFilter: '',
        // 星级筛选
        starFilter: '',
        // 分页相关
        currentPage: 1,
        pageSize: 10,
        totalCount: 6,
        
        // 表单对话框相关
        dialogVisible: false,
        dialogType: 'add', // 'add' 或 'edit'
        packageForm: {
          name: '',
          packageCode: '',
          type: '',
          price: 0,
          duration: 1,
          durationUnit: '月',
          serviceLevel: 3,
          features: [],
          description: '',
          status: '启用',
          image: ''
        },
        // 表单验证规则
        packageRules: {
          name: [
            { required: true, message: '请输入套餐名称', trigger: 'blur' }
          ],
          packageCode: [
            { required: true, message: '请输入套餐编码', trigger: 'blur' }
          ],
          type: [
            { required: true, message: '请选择套餐类型', trigger: 'change' }
          ],
          price: [
            { required: true, message: '请输入套餐价格', trigger: 'blur' }
          ],
          duration: [
            { required: true, message: '请输入套餐时长', trigger: 'blur' }
          ],
          features: [
            { type: 'array', required: true, message: '请至少添加一个套餐特色', trigger: 'change' }
          ],
          description: [
            { required: true, message: '请输入套餐内容描述', trigger: 'blur' }
          ]
        }
      }
    },
    computed: {
      // 过滤后的套餐列表
      filteredPackages() {
        let result = this.packageList;
        
        // 关键词过滤
        if (this.searchKeyword) {
          const keyword = this.searchKeyword.toLowerCase();
          result = result.filter(pkg => 
            pkg.name.toLowerCase().includes(keyword) || 
            pkg.packageCode.toLowerCase().includes(keyword) ||
            pkg.description.toLowerCase().includes(keyword)
          );
        }
        
        // 类型过滤
        if (this.typeFilter) {
          result = result.filter(pkg => pkg.type === this.typeFilter);
        }
        
        // 星级过滤
        if (this.starFilter) {
          const starLevel = parseInt(this.starFilter);
          result = result.filter(pkg => pkg.serviceLevel === starLevel);
        }
        
        return result;
      }
    },
    methods: {
      // 搜索处理
      handleSearch() {
        this.currentPage = 1;
      },
      
      // 添加套餐
      handleAdd() {
        this.dialogType = 'add';
        this.packageForm = {
          name: '',
          packageCode: this.generatePackageCode(),
          type: '',
          price: 0,
          duration: 1,
          durationUnit: '月',
          serviceLevel: 3,
          features: [],
          description: '',
          status: '启用',
          image: ''
        };
        this.dialogVisible = true;
        
        // 确保表单验证信息重置
        this.$nextTick(() => {
          if (this.$refs.packageForm) {
            this.$refs.packageForm.resetFields();
          }
        });
      },
      
      // 编辑套餐
      handleEdit(row) {
        this.dialogType = 'edit';
        
        // 深拷贝数据，避免直接修改表格数据
        this.packageForm = JSON.parse(JSON.stringify(row));
        this.dialogVisible = true;
      },
      
      // 删除套餐
      handleDelete(row) {
        this.$confirm('确定要删除该套餐吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 模拟删除成功
          const index = this.packageList.findIndex(item => item.id === row.id);
          if (index !== -1) {
            this.packageList.splice(index, 1);
            this.totalCount--;
            this.$message.success('删除成功');
          }
        }).catch(() => {
          // 取消删除
        });
      },
      
      // 切换套餐状态
      toggleStatus(row) {
        const newStatus = row.status === '启用' ? '停用' : '启用';
        
        // 模拟更新成功
        const index = this.packageList.findIndex(item => item.id === row.id);
        if (index !== -1) {
          this.packageList[index].status = newStatus;
          this.$message.success(`套餐已${newStatus}`);
        }
      },
      
      // 提交表单
      submitForm() {
        this.$refs.packageForm.validate((valid) => {
          if (valid) {
            this.loading = true;
            setTimeout(() => {
              if (this.dialogType === 'add') {
                // 模拟添加成功
                const newPackage = {
                  ...this.packageForm,
                  id: this.packageList.length + 1
                };
                this.packageList.push(newPackage);
                this.totalCount++;
                this.$message.success('添加成功');
              } else {
                // 模拟编辑成功
                const index = this.packageList.findIndex(item => item.id === this.packageForm.id);
                if (index !== -1) {
                  this.packageList[index] = { ...this.packageForm };
                  this.$message.success('编辑成功');
                }
              }
              this.loading = false;
              this.dialogVisible = false;
            }, 500);
          } else {
            return false;
          }
        });
      },
      
      // 分页相关方法
      handleSizeChange(val) {
        this.pageSize = val;
      },
      handleCurrentChange(val) {
        this.currentPage = val;
      },
      
      // 图片上传相关方法
      handleImageSuccess(res, file) {
        // 模拟上传成功，实际应使用服务器返回的URL
        this.packageForm.image = URL.createObjectURL(file.raw);
      },
      beforeImageUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 2;
  
        if (!isJPG && !isPNG) {
          this.$message.error('上传图片只能是 JPG 或 PNG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!');
        }
        return (isJPG || isPNG) && isLt2M;
      },
      
      // 生成套餐编码
      generatePackageCode() {
        return 'PKG' + (10000 + this.packageList.length + 1);
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .package-management {
    padding: 20px;
    
    h2 {
      margin-bottom: 20px;
      font-weight: 500;
      color: #303133;
    }
    
    .operation-area {
      display: flex;
      margin-bottom: 15px;
    }
    
    .pagination-container {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
    }
    
    .package-name {
      display: flex;
      align-items: center;
    }
    
    .avatar-uploader {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      width: 178px;
      height: 100px;
      
      &:hover {
        border-color: #409EFF;
      }
      
      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 100px;
        line-height: 100px;
        text-align: center;
      }
      
      .avatar {
        width: 178px;
        height: 100px;
        display: block;
        object-fit: cover;
      }
    }
  }
  </style>